import React from 'react';
import { connect } from 'react-redux';
import {getFirstName, getFirstNameStatus, getIsFormValidating, getIsLoadingFirstNameCheck,} from "../../selectors";
import {changeFirstname,} from "../../reducers";
import {showLoader} from "../../utils";
import {FORM_CONSTRAINTS} from "../../constants";

const stateToProps = state => ({
    isFormValidating: getIsFormValidating(state),
    firstnameStatus: getFirstNameStatus(state),
    isLoadingFirstNameCheck: getIsLoadingFirstNameCheck(state),
    firstname: getFirstName(state),
});

const actionsToProps = dispatch => ({
    changeFirstname: payload => dispatch(changeFirstname(payload)),
});

const Name = props => {

    return (
        <div className={`form-row ${props.firstnameStatus}`}>
            <label className="form-label" htmlFor="firstname">
                {props.isLoadingFirstNameCheck && showLoader()}
                Name <span className="asterisk">*</span>
            </label>

            <input type="text" className="form-input" id="firstname" onBlur={props.checkFirstname}
                   value={props.firstname} disabled={props.isFormValidating}
                   onChange={e => {
                       const firstname = e.target.value.trim();
                       if (firstname.length <= FORM_CONSTRAINTS.first_name.max_length) {
                           props.changeFirstname({
                               firstname: firstname,
                               firstnameStatus: 'none',
                               firstnameErrorMessage: '',
                           })}
                   }
                   }
            />
            <i className="form-status" />

            {props.firstnameStatus !== 'error' ? (
                <p className="callout p10 txt-l">
                    Your Bet9ja name/surname must match the Account Holder
                    name of your bank account in order to process a withdrawal..
                </p>
            ) : (
                <p className="callout error p10 txt-l">
                    Invalid Name format. Min. {FORM_CONSTRAINTS.first_name.min_length} characters and max. {FORM_CONSTRAINTS.first_name.max_length}.
                    Special characters and numbers are not allowed. First and Last Name cannot be same.
                </p>
            )}
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(Name);
